export const LegalCaseTypeGetters = {
  selectedLegalCaseTypes: state => state.selectedLegalCaseTypes,

  selectedLegalCaseTypesOptions: state => {
    return state.selectedLegalCaseTypes.map(item => ({
      checklist_id: item.checklist_id,
      description: item.description,
      has_rules: item.has_workflows,
      name: item.name,
      text: `${item.name} - ${item.description}`,
      value: item.id,
    }))
  },
}
